module.exports = __webpack_public_path__ + "static/computer-c6b3840576c7d23b8905867ce21d9a9e.png";